import React from "react";

const SVGCard = (<svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.2222 17.1112H6.11111M16.3333 17.1112H14.4167M1 9.4445H26.5556M1 12.0001C1 7.18155 1 4.77167 2.49756 3.27539C3.99511 1.77911 6.40372 1.77783 11.2222 1.77783H16.3333C21.1518 1.77783 23.5617 1.77783 25.058 3.27539C26.5543 4.77294 26.5556 7.18155 26.5556 12.0001C26.5556 16.8186 26.5556 19.2284 25.058 20.7247C23.5604 22.221 21.1518 22.2223 16.3333 22.2223H11.2222C6.40372 22.2223 3.99383 22.2223 2.49756 20.7247C1.00128 19.2272 1 16.8186 1 12.0001Z"
            stroke="#3A56DF" strokeWidth="2" strokeLinecap="round"/>
    </svg>
)

export default SVGCard